import {
  breakpoints,
  colors,
  components,
  fontFamilies,
  fonts,
  fontSizes,
  fontWeights,
  GlobalStyle,
  gridColumns,
  gridContainer,
  gridGap,
  lineHeights,
  maxWidth,
  media,
  mediaQueriesLegacy,
  motion,
  radii,
  space,
  spacing,
  transitions,
  zIndex,
} from './index';
import type { Theme } from './types';

export { GlobalStyle };
export const theme: Theme = {
  breakpoints,
  colors,
  spacing,
  fontSizes,
  fonts,
  fontFamilies,
  fontWeights,
  gridColumns,
  gridContainer,
  gridGap,
  lineHeights,
  media,
  mediaQueries: mediaQueriesLegacy,
  motion,
  radii,
  space,
  components,
  zIndex,
  transitions,
  maxWidth,
};
export * from './utils';
export * from './mixins';
